import styled, { css } from "styled-components";

export const TextWrapper = styled.div`
 ${({ theme, displayState }) => css`
  display: flex;
  align-items: center;
  
  font-weight: 600;
  font-size: 12px;
  margin-right: ${displayState?.increasePadding ? '120px': ''};
  padding-right: ${displayState?.paddingRight ? displayState?.paddingRight : "30px"};
  color: #9EACB0;
  letter-spacing: 0.1px;
  cursor: pointer;
  `}
`;